import { Standard } from './catalog'

export function standardToString({
  code,
  group,
}: Pick<Standard, 'code' | 'group'>) {
  return `${group} ${code}`
}
